//
//
//
//
//
//
//
//
//
//
export default {
  name: "AppMain",
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.fullPath;
    }
  }
};